import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { Tooltip, Typography } from '@mui/material';
import {
  ContentTooltiptLearningContinuumInfo,
  ContentTooltiptLevelInfo,
  useStyles
} from '../ContentTooltip/ContentTooltip';
import MarkingUtils from '../../../../../../utils/marking.utils';

const isLevelVisible = (levelId, dataHideLevels) => {
  return dataHideLevels[levelId] !== undefined ? dataHideLevels[levelId] : true;
};

const TableRowLevels = ({ lcs, levels, currentCurriculum, size = 30, dataHideLevels = {} }) => {
  const classes = useStyles();
  const lcElement = currentCurriculum?.lcElements?.children?.sort((a, b) => b.position - a.position)[0];

  return (
    <>
      <TableRow key={`guttman-chart-table-lc`}>
        <TableCell
          align='right'
          className={['sticky top-0 left-0px max-w-200px min-w-200px uppercase z-12 bg-background'].join(
            ', '
          )}
          style={{ padding: 0.5 }}
        >
          <Typography
            style={{ height: size }}
            className='rounded bg-muted-foreground text-muted text-sm px-4 flex items-center justify-end font-bold'
          >
            Learning continuum
          </Typography>
        </TableCell>
        {lcs.map((lc) => {
          const colSpan = lc.granularSteps.filter(
            (gs) => gs.isLevel && gs.definition && isLevelVisible(gs.levelId, dataHideLevels)
          ).length;
          return (
            <TableCell
              key={`guttman-chart-table-lc-lc-${lc._id}`}
              colSpan={colSpan}
              width={size * colSpan}
              style={{ padding: 0.5, maxWidth: size * colSpan + 0.5 * colSpan }}
              className='sticky top-0 z-1 text-sm overflow-hidden bg-background'
            >
              <Tooltip
                arrow
                placement='top'
                id={`guttman-chart-table-lc-lc-${lc._id}`}
                title={<ContentTooltiptLearningContinuumInfo lc={lc} currentCurriculum={currentCurriculum} />}
                classes={{ tooltip: classes.customWidthGuttmanChart }}
              >
                <Typography
                  style={{ height: size }}
                  className='rounded bg-muted-foreground text-muted text-nowrap text-sm px-2 flex items-center justify-start'
                >
                  {lc.lcElements[lcElement._id] || 'None'}
                </Typography>
              </Tooltip>
            </TableCell>
          );
        })}
      </TableRow>
      <TableRow key={`guttman-chart-table-levels`}>
        <TableCell
          align='right'
          className={['sticky top-0 left-0px max-w-200px min-w-200px uppercase z-12 bg-background'].join(
            ', '
          )}
          style={{ top: size + 2, padding: 0.5 }}
        >
          <Typography
            style={{ height: size }}
            className='rounded bg-muted-foreground text-muted text-sm px-4 flex items-center justify-end font-bold '
          >
            Levels
          </Typography>
        </TableCell>
        {lcs.map((lc) => {
          return MarkingUtils.sortGranularSteps(
            levels,
            lc.granularSteps.filter(
              (gs) => gs.isLevel && gs.definition && isLevelVisible(gs.levelId, dataHideLevels)
            )
          )
            .reverse()
            .map((gs) => {
              const levelsData = levels.find((level) => level._id === gs.levelId);

              return (
                <TableCell
                  key={`guttman-chart-table-levels-lc-${lc._id}-gs-${gs.id}`}
                  style={{ padding: 0.5, width: size, top: size + 2 }}
                  className='sticky top-0 z-1 text-sm bg-background'
                >
                  <Tooltip
                    arrow
                    placement='top'
                    id={`guttman-chart-table-lc-lc-${lc._id}`}
                    title={
                      <ContentTooltiptLevelInfo
                        level={{
                          levelId: gs.levelId,
                          definition: gs?.definition || '',
                          name: levelsData?.name || ''
                        }}
                      />
                    }
                    classes={{ tooltip: classes.customWidthGuttmanChart }}
                  >
                    <div
                      style={{
                        width: size,
                        height: size
                      }}
                      className='rounded bg-muted-foreground text-muted text-xs flex items-center justify-center text-nowrap'
                    >
                      {levelsData?.shortName}
                    </div>
                  </Tooltip>
                </TableCell>
              );
            });
        })}
      </TableRow>
    </>
  );
};

export default TableRowLevels;
